import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Guideline } from '../shared/models/guideline.model';

@Injectable()
export class GuidelineService {
  private http = inject(HttpClient);


  add(guideline: Guideline): Observable<void> {
    return this.http.post<void>('/api/guideline', guideline);
  }

  getAll(): Observable<Guideline[]> {
    return this.http.get<Guideline[]>('/api/guidelines');
  }

  update(guideline: Guideline): Observable<any> {
    return this.http.put(`/api/guideline/${guideline._id}`, guideline);
  }

  delete(guideline: Guideline): Observable<any> {
    return this.http.delete(`/api/guideline/${guideline._id}`);
  }

}
